import { getWorkspaceNameFromLocalstorage, redirectToSso } from '@neptune/sso-domain';

export async function initializeSso({ authenticated }: { authenticated: boolean }) {
  const hasSsoWorkspace = !!getWorkspaceNameFromLocalstorage();

  if (authenticated || !hasSsoWorkspace) {
    return;
  }

  await redirectToSso();
}
